// Gamme et modèle d'une borne, sans répéter la gamme quand le modèle la
// contient déjà (« Sphérik V2 » et non « Sphérik Sphérik V2 »).
const sansAccents = (s) => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

export function borneType(b) {
  const gamme = (b.gamme_nom || '').trim();
  const model = (b.model_nom || '').trim();
  if (gamme && model && sansAccents(model).startsWith(sansAccents(gamme))) return model;
  return [gamme, model].filter(Boolean).join(' ');
}
